export default __webpack_public_path__ + "static/media/resume.bf33284a.pdf";